<template lang="html">
  <v-form ref="form" lazy-validation>
    <v-card>
      <v-card-title>
        {{ $tc('label.usuario_fornecedor', 1) }}
      </v-card-title>
      <v-container grid-list-xl fluid v-show="isPaginaCarregada">
        <v-row id="dados-sensiveis">
          <v-col cols="12" sm="4" md="4" slot="antes">
            <v-text-field
              :class="{ 'hint-laranja': showHint }"
              :label="`${$t('label.email')} *`"
              ref="email"
              v-model="usuario.email"
              required
              :rules="[rules.requiredText, rules.isEmailValid]"
              maxlength="150"
              autocomplete="null"
              clearable
              counter
              :disabled="isSomenteLeituraDadosSensiveis"
              :hint="showHint ? $t('label.mensagem_inserir_email_pessoal') : ''"
              :persistent-hint="showHint"
              @focus="showHint = true"
              @blur="showHint = false">
            </v-text-field>
          </v-col>
          <v-col cols="12" sm="4" md="4" slot="antes">
            <v-btn
              id="btn_buscar_usario_omni"
              :disabled="isSomenteLeitura || usuario.ehEdicao() || encontrouOmni"
              @click.native="buscarUsuarioOmni">
              {{ $t('label.buscar') }}
            </v-btn>
            <v-btn
              id="btn_limpar_busca"
              class="ml-3"
              :disabled="isSomenteLeitura || usuario.ehEdicao()"
              @click.native="limparFormulario">
              {{ $t('label.limpar') }}
            </v-btn>
          </v-col>
          <v-col cols="12" sm="4" md="4">
            <tenant-usuario-logado-list v-if="tenantsUsuario" :tenants="tenantsUsuario"></tenant-usuario-logado-list>
          </v-col>
          <v-col cols="12" sm="4" md="4" slot="antes">
            <v-text-field
              :label="`${$t('label.login')}`"
              v-model="usuario.nomUsuario"
              disabled
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" md="4" slot="antes">
            <v-text-field
              :label="`${$t('label.nome')} *`"
              v-model="usuario.nome"
              autocomplete="null"
              required
              :rules="[rules.requiredText]"
              maxlength="100"
              counter
              :disabled="isSomenteLeituraDadosSensiveis || desabilitarCadastroFornecedor"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" md="4" slot="antes">
            <v-text-field
              :label="$t('label.sobrenome')"
              v-model="usuario.sobrenome"
              autocomplete="null"
              maxlength="150"
              counter
              :disabled="isSomenteLeituraDadosSensiveis || desabilitarCadastroFornecedor"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" md="4" slot="antes">
            <v-text-field
              :label="`${$t('label.cargo')} *`"
              v-model="usuario.cargo"
              maxlength="50"
              counter
              required
              :rules="[rules.requiredText]"
              :disabled="isSomenteLeituraDadosSensiveis || desabilitarCadastroFornecedor"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="4" md="4" slot="antes">
            <v-text-field
              :label="`${$t('label.documento')} *`"
              v-model="usuario.documento"
              maxlength="50"
              counter
              required
              :rules="[rules.requiredText]"
              :disabled="isSomenteLeituraDadosSensiveis || desabilitarCadastroFornecedor"
            ></v-text-field>
          </v-col>
        </v-row>
        <metadados-container-layout
          v-if="metadadosUsuario"
          :metadados-entidade="metadadosUsuario"
          :objeto="usuario"
          :input-layout="inputLayout"
          :layout-class="layoutClass"
          :somente-leitura="isSomenteLeitura || isUsuarioExternoMaster || desabilitarCadastroFornecedor"
          ref="containerUsuario"
          @MetadadosContainerLayout_valorAlterado="valorAlterado">
          <v-col cols="12" sm="4" md="4" slot="antes">
            <v-autocomplete
              id="usuario-perfil"
              class="custom-autocomplete"
              :disabled="isSomenteLeitura || isUsuarioExternoMaster || desabilitarCadastroFornecedor"
              required
              :rules="[rules.required]"
              :no-data-text="$tc('message.nenhum_registro', 1)"
              :label="`${$tc('label.perfil', 1)} *`"
              v-model="usuario.idPerfil"
              :items="perfis"
              item-text="nomPerfil"
              item-value="id"
              clearable>
            </v-autocomplete>
          </v-col>
          <v-col cols="12" sm="2" slot="depois">
            <v-switch
              color="primary"
              :label="$t('label.recebe_mail')"
              :disabled="isSomenteLeitura || desabilitarCadastroFornecedor"
              v-model="usuario.indRecebeMail">
            </v-switch>
          </v-col>
          <v-col cols="12" sm="2" slot="depois" :key="panelKey">
            <v-switch
              color="primary"
              :label="$t('label.ativo')"
              :disabled="desabilitarFlagAtivo"
              @change="changeIndAtivo()"
              v-model="usuario.indAtivo"
              :rules="[v => rules.requiredAtivoAprAutorizado(v)]">
            </v-switch>
          </v-col>
          <v-col cols="12" sm="2" slot="depois">
            <v-switch
              color="primary"
              :label="$t('label.tipos_fornecedor.representante_legal')"
              :disabled="desabilitarFlagUsuarioMaster"
              @click="triggerAtivaUsuarioMaster()"
              v-model="usuario.indUsuarioExternoMaster">
            </v-switch>
          </v-col>
          <v-col cols="12" sm="2" slot="depois">
            <v-switch
              color="primary"
              :label="$t('label.procurador')"
              :disabled="isSomenteLeitura || !usuarioLogadoFuncionario || desabilitarCadastroFornecedor
               || !podeCadastrarFornecedorRepresentanteLegal || !usuario.indUsuarioExternoMaster"
              v-model="usuario.indProcurador"
              @click="isProcurador(usuario.indProcurador)"
              >
            </v-switch>
          </v-col >
          <v-col cols="12" md="2" slot="depois" v-if="exibirCamposDeData">
            <v-menu
              :key="menuKey"
              v-model="menuInicio"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-on="on"
                  :label="`${$tc('label.inicio_vigencia', 1)} * `"
                  :rules="[rules.requiredVigencia, rules.validDate]"
                  :disabled="isSomenteLeitura || !usuario.indProcurador || desabilitarCadastroFornecedor"
                  v-model="dtaInicioVigenciaFormatada"
                  :return-masked-value="true"
                  v-mask="'##/##/####'"
                  prepend-icon="event"
                  :hint="!!usuario.dtaInicioVigenciaPrevia ? `${$tc('label.nova_data_em_analise', 1)}: ` + dtaInicioVigenciaPreviaFormatada : ''"
                  :persistent-hint="!!usuario.dtaInicioVigenciaPrevia"
                ></v-text-field>
              </template>
              <v-date-picker
                locale="pt-br"
                v-model="dtaInicioVigencia"
                @input="menuInicio = false, setarDataInicioNoUsuario()"
              ></v-date-picker>
            </v-menu>
          </v-col>
          <v-col cols="12" md="2" slot="depois" v-if="exibirCamposDeData">
            <v-menu
              v-model="menuFim"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-on="on"
                  :label="`${$tc('label.fim_vigencia', 1)} * `"
                  :rules="regrasDataFim"
                  :disabled="isSomenteLeitura || !usuario.indProcurador || desabilitarCadastroFornecedor"
                  v-model="dtaFimVigenciaFormatada"
                  :return-masked-value="true"
                  v-mask="'##/##/####'"
                  prepend-icon="event"
                  :hint="!!usuario.dtaFimVigenciaPrevia ? `${$tc('label.nova_data_em_analise', 1)}: ` + dtaFimVigenciaPreviaFormatada : ''"
                  :persistent-hint="!!usuario.dtaFimVigenciaPrevia"
                ></v-text-field>
              </template>
              <v-date-picker
                locale="pt-br"
                v-model="dtaFimVigencia"
                @input="menuFim = false, setarDataFimNoUsuario()"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </metadados-container-layout>
        <div v-if="usuario.indUsuarioExternoMaster && !usuario.indProcurador">{{$tc('message.vigencia_representante_legal')}}</div>

        <div v-if="usuario.indUsuarioExternoMaster" :key="tableRepConjKey">
          <v-container fluid grid-list-md>
            <v-row>
              <v-col cols="12" :sm="indGrupoFornecedorPossuiRepConjunto ? 6 : 12" v-if="(podeCadastrarAnexos || podeVisualizarAnexos)">
                <div class="mt-3 mb-2 title-float accent--text">
                  {{$tc('label.anexo', 2)}}
                </div>
                <v-card>
                  <v-container fluid grid-list-md>
                    <usuario-form-arquivo
                      :is-novo-cadastro="isNovoCadastro"
                      :usuario="usuario"
                      :pode-visualizar-anexos="!!(podeVisualizarAnexos && usuario.id && isUsuarioFornecedor)"
                      :pode-cadastrar-anexos="!!(podeCadastrarAnexos && isUsuarioFornecedor && usuario.id)"
                      :habilita-anexo-fornecedor="true"
                      @FormAnexoArquivo__qtde="setQuantidadeArquivos">
                    </usuario-form-arquivo>
                  </v-container>
                </v-card>
              </v-col>
              <v-col cols="12" :sm="(podeCadastrarAnexos || podeVisualizarAnexos) ? 6 : 12" v-if="indGrupoFornecedorPossuiRepConjunto">
                <div class="mt-3 mb-2 title-float accent--text">
                  {{ $tc('label.representacao_conjunto', 1) }} - {{ $tc('label.grupo_rep_legal', 2) }}
                </div>
                <v-card>
                  <v-container fluid grid-list-md>
                    <usuario-form-grupo-rep-conjunto
                      :id-grupo-fornecedor="usuario.grupofornecedor.id">
                    </usuario-form-grupo-rep-conjunto>
                  </v-container>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </div>
        <span v-if="!usuario.indUsuarioExternoMaster">{{ $tc('message.vigencia_aprovador_autorizado', 1) }}</span>
      </v-container>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click=""
          dark
          color="red"
          @click.native="validarSalvarUsuarioComRenovacaoVigencia"
          v-show="isAprovadorAutorizado && (usuario.dataVigenciaAExpirar || usuario.dataVigenciaExpirada)
           && !isUsuarioExternoMaster && !usuario.indUsuarioExternoMaster && !indUsuarioExternoMasterOriginal">
          {{ $t('label.renovar_vigencia') }}
        </v-btn>
        <v-btn v-if="isSomenteLeitura" @click.native="cancel">{{ $t('label.voltar') }}</v-btn>
        <v-btn v-if="!isSomenteLeitura" @click.native="openCancelarDialog">{{ $t('label.cancelar') }}</v-btn>
        <v-btn v-if="!isSomenteLeitura" @click.native="validarSalvar" color="primary">{{ $t('label.salvar') }}</v-btn>
        <v-btn @click=""
          class="mr-3"
          dark
          color="red"
          @click.native="preparaDataSolicitarAprovacao"
          v-show="!isUsuarioAprovador && (podeSolicitarAprovacao || (usuarioAprovadoNaoProcurador && usuario.indProcurador))">
          {{ $t('label.solicitar_aprovacao') }}
        </v-btn>
        <v-btn @click=""
          dark
          color="primary"
          @click.native="openModalJustificativaAprovacao('APROVADO', $t('label.aprovar'))"
          v-show="podeAprovarRepresentanteLegal">
          {{ $t('label.aprovar') }}
        </v-btn>
        <v-btn @click=""
          class="mr-3"
          dark
          color="red"
          @click.native="openModalJustificativaAprovacao('REPROVADO', $t('label.reprovar'))"
          v-show="podeReprovarRepresentanteLegal">
          {{ $t('label.reprovar') }}
        </v-btn>
      </v-card-actions>
    </v-card>

    <confirm
      ref="confirmDialog"
      :message="dialog.content"
      :persistent="true"
      @agree="dialog.action">
    </confirm>

    <confirm
      ref="confirmDialogAlterouGrupoFornecedor"
      :message="dialog.content"
      :persistent="true"
      :max-width="'600'"
      @agree="dialog.action">
    </confirm>

    <confirm
      ref="confirmDialogSolicitarAprovacao"
      :persistent="true"
      :max-width="'600'"
      :agree-label="$t('label.sim')"
      :disagree-label="$t('label.nao')"
      @disagree="resetaStatusParaSalvar"
      />

    <confirm
      ref="cancelarDialog" :title="$t('title.atencao')"
      :message="$t('message.tem_certeza_cancelar')"
      @agree="cancel">
    </confirm>

    <confirm
      ref="avisoAnexoDialog" :title="$t('title.atencao')"
      :message="$t('message.aviso_anexo_obrigatorio')"
      :hide-disagree="true"
      :persistent="true"
      :agree-label="$t('label.ok')"
      @agree="desativarUsuario">
    </confirm>

    <confirm
      ref="avisoAnexoUsuarioAntigoDialog" :title="$t('title.atencao')"
      :message="$t('message.aviso_anexo_obrigatorio_solicitar_aprovacao_usuario')"
      :persistent="true"
      :hide-disagree="true"
      :agree-label="$t('label.ok')">
    </confirm>

    <usuario-form-termo-aceite-dialog
      v-if="termoAceite !== null && termoAceite.indAtivo"
      ref="termoAceiteDialog"
      :termo-aceite="termoAceite"
      @Finalizar="finalizar">
    </usuario-form-termo-aceite-dialog>
    <usuario-aprovacao-dialog
      ref="modalJustificativaAprovacao"
      :title="titleJustificativaModal"
      :obrigatorio="statusAprovacaoUsuario !== 'APROVADO'"
      @Afirmativo="aprovarReprovarUsuario">
    </usuario-aprovacao-dialog>
    <usuario-data-alteracao-dialog
      ref="modalDataAlteracao"
      :nome-perfil-aprovador-fluxo="usuario.nomePerfilAprovador"
      @CancelarEdicaoData="cancelarEdicaoData"
      @SolicitarAprovacaoEdicaoData="preparaDataSolicitarAprovacao">
    </usuario-data-alteracao-dialog>
    <modal-dados-fluxos-de-aprovacao-impactados-por-inativacao-usuario
     ref="modalDadosFluxosDeAprovacaoImpactadosPorInativacaoUsuario"
     @disagree="cancelaAcaoInativar"
     @agree="alterarStatusEntidadesImpactadasPorInativacaoUsuario"
     :existe-fluxos-impactados-por-inativacao="existeFluxosImpactadosPorInativacao"
    >
    </modal-dados-fluxos-de-aprovacao-impactados-por-inativacao-usuario>
  </v-form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { montarEstruturaDinamica } from '@/common/functions/metadados';
import { generateComputed } from '@/common/functions/roles-computed-generator';
import { copyObject } from '@/common/functions/helpers';
import { enviarEmailAvisoInativacaoFornecedor } from '@/common/resources/workflow-acao';
import Usuario from '@/spa/usuario/Usuario';
import Confirm from '@/shared-components/dialog/Confirm';
import MetadadosContainerLayout from '@/shared-components/metadados/MetadadosContainerLayout';
import UsuarioFormArquivo from '@/spa/usuario/UsuarioFormArquivo';
import UsuarioFormTermoAceiteDialog from '@/spa/usuario/UsuarioFormTermoAceiteDialog';
import UsuarioAprovacaoDialog from '@/spa/usuario/UsuarioAprovacaoDialog';
import UsuarioDataAlteracaoDialog from '@/spa/usuario/UsuarioDataAlteracaoDialog';
import ModalDadosFluxosDeAprovacaoImpactadosPorInativacaoUsuario from '@/shared-components/ModalDadosFluxosDeAprovacaoImpactadosPorInativacaoUsuario';
import UsuarioFormGrupoRepConjunto from '@/spa/usuario/UsuarioFormGrupoRepConjunto';
import {
  formatDateDDMMYYYYBarras,
  parseDateYYYYMMDDBarras,
} from '@/common/functions/date-utils';
import {
  forceHideLoading,
  forceLoading,
  skipLoading,
} from '@/common/functions/loading';
import TenantUsuarioLogadoList from '../../shared-components/tenant/TenantUsuarioLogadoList';

export default {
  name: 'UsuarioFornecedorForm',
  props: {
    somenteLeitura: Boolean,
    default: false,
  },
  components: {
    Confirm,
    MetadadosContainerLayout,
    UsuarioFormArquivo,
    UsuarioFormTermoAceiteDialog,
    UsuarioAprovacaoDialog,
    UsuarioDataAlteracaoDialog,
    TenantUsuarioLogadoList,
    ModalDadosFluxosDeAprovacaoImpactadosPorInativacaoUsuario,
    UsuarioFormGrupoRepConjunto,
  },
  computed: {
    ...mapGetters('metadados', [
      'getUsuarioMetadado',
    ]),
    ...mapGetters('usuario', [
      'usuarioLogado',
    ]),
    ...mapGetters('roles', [
      'getAllRoles',
      'getTenantId',
    ]),
    ...mapGetters('implantacao', [
      'indAmbienteProdutivo',
    ]),
    ...generateComputed('usr', [
      'canPost',
      'canEdit',
      'canSearch',
      'canAccessCRUD',
    ]),
    ...mapGetters('implantacao', [
      'chaveEmpresa',
    ]),
    dtaInicioVigenciaFormatada: {
      get() {
        if (this.dtaInicioVigencia) {
          return formatDateDDMMYYYYBarras(this.dtaInicioVigencia);
        }
        if (this.usuario?.dtaInicioVigenciaPrevia) {
          return formatDateDDMMYYYYBarras(this.usuario.dtaInicioVigenciaPrevia);
        }
        return null;
      },
      set(newValue) {
        this.dtaInicioVigencia = newValue ? parseDateYYYYMMDDBarras(newValue) : null;
        this.usuario.dtaInicioVigencia = newValue ? parseDateYYYYMMDDBarras(newValue) : null;
      },
    },
    dtaFimVigenciaFormatada: {
      get() {
        if (this.dtaFimVigencia) {
          return formatDateDDMMYYYYBarras(this.dtaFimVigencia);
        }
        if (this.usuario?.dtaFimVigenciaPrevia) {
          return formatDateDDMMYYYYBarras(this.usuario.dtaFimVigenciaPrevia);
        }
        return null;
      },
      set(newValue) {
        this.dtaFimVigencia = newValue ? parseDateYYYYMMDDBarras(newValue) : null;
        this.usuario.dtaFimVigencia = newValue ? parseDateYYYYMMDDBarras(newValue) : null;
      },
    },
    dtaInicioVigenciaPreviaFormatada: {
      get() {
        return this.usuario.dtaInicioVigenciaPrevia ? formatDateDDMMYYYYBarras(this.usuario.dtaInicioVigenciaPrevia) : null;
      },
      set(newValue) {
        this.usuario.dtaInicioVigenciaPrevia = newValue ? parseDateYYYYMMDDBarras(newValue) : null;
      },
    },
    dtaFimVigenciaPreviaFormatada: {
      get() {
        return this.usuario.dtaFimVigenciaPrevia ? formatDateDDMMYYYYBarras(this.usuario.dtaFimVigenciaPrevia) : null;
      },
      set(newValue) {
        this.usuario.dtaFimVigenciaPrevia = newValue ? parseDateYYYYMMDDBarras(newValue) : null;
      },
    },
    podeCadastrarFornecedorRepresentanteLegal() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter((el) => el === 'USR_CADASTRAR_GESTAO_DE_FORNECEDOR_REPRESENTANTE_LEGAL').length;
    },
    podeCadastrarFornecedorMaster() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter((el) => el === 'USR_CADASTRAR_GESTAO_DE_FORNECEDOR_MASTER').length;
    },
    permissaoSolicitarAprovacao() {
      if (!this.getAllRoles) {
        return false;
      }
      return !!this.getAllRoles
        .filter((el) => el === 'SOLICITAR_APROVACAO_USUARIO').length;
    },
    isNovoCadastro() {
      return !this.idUsuario && !this.usuario.id;
    },
    usuarioLogadoFuncionario() {
      return this.usuarioLogado.tipo === 'FUNCIONARIO';
    },
    usuarioLogadoFornecedor() {
      return this.usuarioLogado.tipo === 'FORNECEDOR';
    },
    metadadosUsuario() {
      if (this.getUsuarioMetadado && this.getUsuarioMetadado.mapaEntidades) {
        if (!this.isUsuarioFuncionario && this.getUsuarioMetadado.mapaEntidades.grupofornecedor) {
          delete this.getUsuarioMetadado.mapaEntidades.grupofornecedor;
          return this.getUsuarioMetadado;
        }
        return this.getUsuarioMetadado;
      }
      return undefined;
    },
    isUsuarioExternoMaster() {
      return this.usuarioLogado.indUsuarioExternoMaster;
    },
    isUsuarioFuncionario() {
      return this.usuarioLogado.tipo === 'FUNCIONARIO';
    },
    podeVisualizarAnexos() {
      return this.canSearch;
    },
    podeCadastrarAnexos() {
      return this.canAccessCRUD && this.isUsuarioFuncionario;
    },
    podeSolicitarAprovacao() {
      if (this.indAprovadoAExpirar) {
        return this.usuario.statusFluxo && this.usuario.indUsuarioExternoMaster
        && this.indFluxoAprovacaoRepreLegal && this.permissaoSolicitarAprovacao
        && this.usuario.indAtivo && !this.isGrupoFornecedorAlterado;
      }

      return ((this.usuario.statusFluxo && !['AGUARDANDO_APROVACAO', 'APROVADO', 'EM_ANALISE'].includes(this.usuario.statusFluxo))
      || (!this.usuario.statusFluxo && this.usuario.id))
       && this.usuario.indUsuarioExternoMaster && this.indFluxoAprovacaoRepreLegal && this.permissaoSolicitarAprovacao && !this.usuario.indAtivo
       && !this.isGrupoFornecedorAlterado;
    },
    podeAprovarRepresentanteLegal() {
      return this.usuarioLogado.idPerfil === parseInt(this.usuario.perfilAprovador, 10)
        && ['AGUARDANDO_APROVACAO', 'EM_ANALISE'].includes(this.usuario.statusFluxo) && this.quantidadeArquivos >= 1;
    },
    podeReprovarRepresentanteLegal() {
      return this.usuarioLogado.idPerfil === parseInt(this.usuario.perfilAprovador, 10)
        && ['AGUARDANDO_APROVACAO', 'EM_ANALISE'].includes(this.usuario.statusFluxo);
    },
    habilitaCampoDataSemIndProcurador() {
      return this.usuario.indUsuarioExternoMaster && !this.flagProcurador && !this.isNovoCadastro
       && ((this.usuario.statusFluxo && this.usuario.statusFluxo === 'APROVADO') || !this.usuario.statusFluxo)
       && this.usuario.dtaInicioVigencia && this.usuario.dtaFimVigencia && !this.dataApagada;
    },
    habilitaCampoAprovadorAutorizado() {
      return this.isAprovadorAutorizado && !this.isNovoCadastro;
    },
    isDataAlterada() {
      return ((this.usuario.dtaInicioVigencia && this.dtaInicioVigenciaOriginal !== this.usuario.dtaInicioVigencia)
        || (this.usuario.dtaFimVigencia && this.dtaFimVigenciaOriginal !== this.usuario.dtaFimVigencia));
    },
    isDataInicioVigenciaAlterada() {
      return this.usuario.dtaInicioVigencia && this.dtaInicioVigenciaOriginal !== this.usuario.dtaInicioVigencia;
    },
    desabilitarFlagUsuarioMaster() {
      return this.isSomenteLeitura || this.desabilitarCadastroFornecedor
      || (this.podeCadastrarFornecedorRepresentanteLegal && !this.podeCadastrarFornecedorMaster)
      || (this.podeCadastrarFornecedorMaster && !this.podeCadastrarFornecedorRepresentanteLegal)
      || (!this.isNovoCadastro && this.usuario.indProcuradorVigenciaExpirada);
    },
    desabilitarFlagAtivo() {
      return this.isSomenteLeitura || this.desabilitarCadastroFornecedor
      || (!this.isNovoCadastro && ['AGUARDANDO_APROVACAO'].includes(this.usuario.statusFluxo) && !this.usuario.indAtivo)
      || (!this.isNovoCadastro && !this.usuario.indUsuarioExternoMaster && !this.flagProcurador && this.usuario.dataVigenciaExpirada);
    },
    isUsuarioFornecedor() {
      return this.usuario.tipo === 'FORNECEDOR';
    },
    isUsuarioAprovador() {
      return this.usuarioLogado.idPerfil === this.idPerfilAprovador;
    },
    isDtaFinalMenorQueDtaAtual() {
      return this.usuario.indProcurador && !this.isDataNaoVencida() && this.usuario.indAtivo && this.isUsuarioAprovador;
    },
    isGrupoFornecedorAlterado() {
      return !this.isNovoCadastro && (!this.idGrupoFornecedorAtual
        || (!this.idGrupoFornecedorOriginal && !!this.idGrupoFornecedorAtual)
        || (!!this.idGrupoFornecedorOriginal && !!this.idGrupoFornecedorAtual
        && this.idGrupoFornecedorOriginal !== this.idGrupoFornecedorAtual));
    },
    indGrupoFornecedorPossuiRepConjunto() {
      return !!this.idGrupoFornecedorAtual
        && ((!!this.usuario.grupofornecedor && this.usuario.grupofornecedor.indPossuiRepresentacaoConjunto)
        || (this.usuario.grupofornecedor.indPossuiRepresentacaoConjunto === undefined && this.usuario.indGrupoPossuiRepresentacaoConjunto));
    },
    indAprovadoAExpirar() {
      return this.usuario.statusFluxo === 'APROVADO' && this.usuario.dataVigenciaAExpirar;
    },
    desabilitarCadastroFornecedor() {
      return this.isNovoCadastro && !this.buscouOmni;
    },
    isSomenteLeitura() {
      if (this.forcaSomenteLeitura) {
        return true;
      }
      return this.somenteLeitura;
    },
    exibeTermoCadastro() {
      return this.termoAceite && this.termoAceite.indAtivo && !this.usuario.indUsuarioExternoMaster
      && this.usuarioLogadoFornecedor && ((!this.indAtivoOriginal && this.usuario.indAtivo) || !this.existeTermoAceite);
    },
    isSomenteLeituraDadosSensiveis() {
      if (this.forcaSomenteLeitura) {
        return true;
      }
      return (!this.isNovoCadastro || this.encontrouOmni) && this.tenantsUsuario && (this.tenantsUsuario.length > 1
      || (this.tenantsUsuario.length === 1 && this.tenantsUsuario[0].toUpperCase() !== this.chaveEmpresa));
    },
    exibirCamposDeData() {
      const isUsuarioMasterEProcurador = this.habilitaCampoDataSemIndProcurador || (this.usuario.indUsuarioExternoMaster && this.flagProcurador);
      const isUsuarioAprovadorAutorizado = this.habilitaCampoAprovadorAutorizado && !this.usuario.indUsuarioExternoMaster
       && this.usuario.dtaInicioVigencia && this.usuario.dtaFimVigencia && !this.dataApagada;
      return isUsuarioMasterEProcurador || isUsuarioAprovadorAutorizado;
    },
    regrasDataFim() {
      const baseRules = [
        this.rules.requiredVigencia,
        this.rules.validDate,
        this.rules.dataFimMaiorInicio,
        this.rules.dataFimExpiraTrintaDias,
      ];
      const deveIgnorarRegraVencida = (!this.isNovoCadastro && this.usuario.indUsuarioExternoMaster && !this.indAtivoOriginal
       && !this.usuario.indProcurador && !this.isDataNaoVencida())
       || (this.habilitaCampoAprovadorAutorizado && !this.usuario.indUsuarioExternoMaster);
      if (!deveIgnorarRegraVencida) {
        baseRules.push(this.rules.dataFimVencida);
      }
      return baseRules;
    },
  },
  data() {
    return {
      showHint: false,
      usuarioResource: this.$api.usuario(this.$resource),
      perfilResource: this.$api.perfil(this.$resource),
      extensaoResources: this.$api.extensao(this.$resource),
      resourceMetadado: this.$api.metadado(this.$resource),
      termoAceiteResources: this.$api.termoAceite(this.$resource),
      configSistemaResource: this.$api.configuracaoSistema(this.$resource),
      workflowAcaoResource: this.$api.workflowAcao(this.$resource),
      workflowApuracaoAcaoResource: this.$api.workflowApuracaoAcao(this.$resource),
      workflowContratoResource: this.$api.workflowContrato(this.$resource),
      representacaoConjuntoResource: this.$api.representacaoConjunto(this.$resource),
      dialog: {
        ref: 'dialog1',
        from: 'saveRegisterFromButton',
        title: this.$t('label.atencao'),
        content: '',
        action() {},
      },
      rules: {
        required: (value) => !!value || this.$t('message.campo_obrigatorio'),
        requiredText: (value) => (!!value && !!value.trim()) || this.$t('message.campo_obrigatorio'),
        isLoginValid: (value) => (!!value && value.trim() !== this.loginAntigo) || this.$t('message.login_existente'),
        requiredTags: (value) => value.length > 0 || this.$t('message.campo_obrigatorio'),
        isEmailValid: (value) => this.emailReg.test(value) || this.$t('message.campo_obrigatorio_ou_invalido'),
        requiredVigencia: (value) => (!!value && !!value.trim()) || this.$t('message.campo_obrigatorio'),
        dataFimMaiorInicio: () => this.isDataFimMaiorInicio() || this.$t('message.data_inicial_maior_final'),
        dataFimVencida: () => this.isDataNaoVencida() || this.$t('message.data_final_menor_data_atual'),
        dataFimExpiraTrintaDias: () => this.isDataNaoVencidaEmTrintaDias() || this.$t('message.data_final_vence_trinta_dias'),
        validDate: (value) => (!value || (value.length === 10 && this.moment(value, 'DD/MM/YYYY').isValid())) || this.$t('message.data_invalida'),
        requiredAtivoAprAutorizado: (value) => {
          const isCadastroAprAutorizadoInativo = !this.usuario.indUsuarioExternoMaster && !value && this.isNovoCadastro;
          if (isCadastroAprAutorizadoInativo) {
            return this.$t('message.campo_obrigatorio');
          }
          return true;
        },
      },
      perfis: [],
      extensoes: [],
      niveisExtensoes: [],
      nivel: {},
      dadosFluxosAprovacaoImpactados: {},
      indFluxoAprovacaoRepreLegal: false,
      isSolicitandoAprovacao: false,
      usuario: new Usuario(null, 'FORNECEDOR'),
      grupoFornecedorEdicao: {},
      idGrupoFornecedorEdicao: null,
      tenantsUsuario: null,
      usuarioAprovadoNaoProcurador: false,
      indDtaPreviaAlteradaPorAprovador: false,

      inputLayout: {
        xs12: true,
        sm12: false,
        sm6: true,
        md3: false,
        md4: true,
        md6: false,
        md9: false,
        md12: false,
      },

      layoutClass: { wrap: true },

      termoAceite: null,
      quantidadeArquivos: 0,
      menuInicio: false,
      menuFim: false,
      flagProcurador: false,
      emailReg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      statusAprovacaoUsuario: '',
      justificativaAprovacaoReprovacaoUsuario: '',
      titleJustificativaModal: '',
      dtaInicioVigenciaOriginal: '',
      dtaFimVigenciaOriginal: '',
      menuKey: 0,
      usuarioSemEdicao: {},
      existeTermoAceite: false,
      isPaginaCarregada: false,
      panelKey: 0,
      encontrouOmni: false,
      dtaInicioVigencia: '',
      dtaFimVigencia: '',
      idPerfilAprovador: null,
      indAtivoOriginal: false,
      indUsuarioExternoMasterOriginal: false,
      idGrupoFornecedorOriginal: null,
      idGrupoFornecedorAtual: null,
      nomeGrupoFornecedorOriginal: '',
      indHabilitaAlterarFluxosImpactados: false,
      desabilitaFluxoAprovacaoUsuarioInativo: false,
      dataApagada: false,
      existeFluxosImpactadosPorInativacao: false,
      existeGrupoRepresentacaoConjuntoImpactadoPorAlteracaoDeGrupo: false,
      loginAntigo: '',
      statusParaSalvar: null,
      buscouOmni: false,
      forcaSomenteLeitura: false,
      tableRepConjKey: 0,
      indRenovaVigencia: false,
      indCancelandoEdicao: false,
    };
  },
  methods: {
    copyObject,
    ...mapActions('metadados', [
      'setUsuarioMetadado',
    ]),
    isProcurador(isProcurador, carregouTela = false) {
      this.flagProcurador = isProcurador;
      if (!isProcurador && !carregouTela) {
        this.usuario.dtaFimVigencia = null;
        this.usuario.dtaInicioVigencia = null;
        this.dtaFimVigenciaFormatada = null;
        this.dtaInicioVigenciaFormatada = null;
        this.dataApagada = true;
      }
      if (isProcurador && this.usuarioAprovadoNaoProcurador) {
        this.usuario.indAtivo = false;
      }
      this.$forceUpdate();
    },
    isAprovadorAutorizado() {
      return !this.usuario.indUsuarioExternoMaster;
    },
    buscarUsuarioOmni() {
      if (!this.$refs.email.validate(true)) return;

      const { tipo, email } = this.usuario;
      const filtro = { tipo, email };

      this.usuarioResource.buscarNoOmni(filtro)
        .then((res) => {
          const usuarioOmni = res.data;
          const inativarUsuario = this.podeCadastrarFornecedorRepresentanteLegal && !this.podeCadastrarFornecedorMaster;

          this.usuario.construirAPartirUsuarioOmni(usuarioOmni, inativarUsuario);
          if (!this.isUsuarioExternoMaster) {
            const perfil = this.perfis.find((p) => p.idExterno === usuarioOmni.idPerfil);
            this.usuario.idPerfil = perfil ? perfil.id : null;
          }
          this.tenantsUsuario = res.data.tenants.map((t) => t.tenant);
          this.usuario.indOrigemOmni = true;
          this.encontrouOmni = true;
          this.isProcurador(this.usuario.indProcurador);
          this.buscouOmni = true;
        })
        .catch((err) => {
          if (err.bodyText && JSON.parse(err.bodyText).erros
              && JSON.parse(err.bodyText).erros[0] === 'usuario.ja_cadastrado') {
            this.buscouOmni = false;
            this.$error(this, err);
          } else {
            this.usuario.nomUsuario = this.usuario.email;
            this.buscouOmni = true;
            this.$error(this, err);
          }
        });
    },
    popularMetadadosUsuario() {
      if (this.getUsuarioMetadado) {
        return;
      }
      this.setUsuarioMetadado({
        resource: this.resourceMetadado.listarUsuario,
      });
    },
    limparFormulario() {
      this.usuario = new Usuario(null, 'FORNECEDOR');
      this.encontrouOmni = false;
      this.tenantsUsuario = null;
      this.$refs.form.reset();
      setTimeout(() => {
        if (this.podeCadastrarFornecedorRepresentanteLegal && !this.podeCadastrarFornecedorMaster) this.usuario.indUsuarioExternoMaster = true;
        this.usuario.indRecebeMail = true;
        this.isProcurador(this.usuario.indProcurador);
        this.selecionarPerfilAuto();
        this.indAtivoPadrao();
      }, 1e2);
    },
    cancel() {
      this.indCancelandoEdicao = true;
      this.limparFormulario();
      this.$router.push({ name: 'usuario-fornecedor' });
    },
    openCancelarDialog() {
      this.$refs.cancelarDialog.open();
    },
    finalizar() {
      this.setDialogContent(null, this.save, this.dialog.from);
      this.$refs.confirmDialog.open();
    },
    openSaveDialog(ref, from) {
      if (!this.$refs.form.validate()) return;
      const content = this.$t('message.salvar_usuario');
      this.setDialogContent(content, this.save, from || this.dialog.from);
      if (this.exibeTermoCadastro) {
        this.$refs.termoAceiteDialog.open(this.usuario.email, 'razaoSocial', `${this.usuario.nome} ${this.usuario.sobrenome ? this.usuario.sobrenome : ''}`);
      } else if (this.usuario.indUsuarioExternoMaster && this.podeCadastrarAnexos
          && this.quantidadeArquivos < 1 && !this.usuario.indAtivo) {
        this.save();
      } else if (this.usuario.indUsuarioExternoMaster && this.podeCadastrarAnexos
          && this.quantidadeArquivos < 1 && this.usuario.indAtivo) {
        this.$refs.avisoAnexoDialog.open();
      } else if (this.usuario.indProcurador && this.isDataAlterada && !this.isUsuarioAprovador) {
        this.openModalAlteracaoData();
      } else {
        this.$refs.confirmDialog.open();
      }
    },
    preparaDataSolicitarAprovacao() {
      let dataAlterada = false;
      this.isSolicitandoAprovacao = true;
      if (this.indAprovadoAExpirar && !this.usuario.indProcurador) {
        this.dataApagada = true;
      } else if (this.indAprovadoAExpirar && this.usuario.indProcurador) {
        dataAlterada = true;
      }
      this.$nextTick(() => {
        setTimeout(() => {
          this.openSolicitarAprovacaoDialog(dataAlterada);
        });
      });
    },
    openSolicitarAprovacaoDialog(dataAlterada = false) {
      if (this.quantidadeArquivos < 1) {
        this.$refs.avisoAnexoUsuarioAntigoDialog.open();
      } else {
        if (!this.$refs.form.validate()) {
          this.dataApagada = false;
          this.isSolicitandoAprovacao = false;
          return;
        }
        this.save('AGUARDANDO_APROVACAO', dataAlterada);
      }
    },
    openModalJustificativaAprovacao(status, titleModal) {
      if (this.isUsuarioAprovador && status === 'REPROVADO' && this.usuario.indUsuarioExternoMaster
       && this.indAtivoOriginal && this.existeFluxosImpactadosPorInativacao) {
        const dados = {
          idUsuario: this.usuario.id,
          nomeFornecedor: this.usuario.nomeSobrenome,
          dadosFluxosAprovacaoImpactados: this.dadosFluxosAprovacaoImpactados,
          indReprovacaoUsuarioFornecedorMaster: true,
        };
        setTimeout(() => this.$refs.modalDadosFluxosDeAprovacaoImpactadosPorInativacaoUsuario.open(dados), 2E2);
        return;
      }
      if (!this.$refs.form.validate()) {
        return;
      }
      this.titleJustificativaModal = titleModal;
      this.statusAprovacaoUsuario = status;
      this.statusAprovadoRepresentanteLegal = status;
      this.$refs.modalJustificativaAprovacao.open();
    },
    aprovarReprovarUsuario(justificativa) {
      this.justificativaAprovacaoReprovacaoUsuario = justificativa;
      this.save(this.statusAprovadoRepresentanteLegal);
    },
    buscarExtensoes(idGrupoFornecedor = null) {
      const params = {
        idNivelExtensao: 3,
        indUsuarioExterno: true,
      };
      if (idGrupoFornecedor) {
        params.idExtensao = idGrupoFornecedor;
      }
      return this.extensaoResources.listarPorUsuario(params)
        .then((res) => {
          this.extensoes = res.data.resposta;
          if (this.extensoes.length === 1) {
            const [grupoForn] = this.extensoes;
            this.usuario.grupofornecedor = grupoForn;
            this.usuario.id_grupofornecedor = grupoForn.id;
            this.grupoFornecedorEdicao = grupoForn;
            this.idGrupoFornecedorEdicao = grupoForn.id;
            this.$refs.containerUsuario.refresh();
          }
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    save(statusFluxo = null, dataAlterada = false) {
      this.aplicarTrimCamposTexto();
      if (this.indAprovadoAExpirar && !this.usuario.indProcurador && this.isSolicitandoAprovacao) {
        this.usuario.dtaFimVigencia = null;
        this.usuario.dtaInicioVigencia = null;
      }
      const objArmazenamento = {
        ...this.usuario,
        ...this.$refs.containerUsuario.getValoresDependencias(),
        tenant: this.getTenantId,
      };
      if (this.statusParaSalvar !== null) {
        statusFluxo = this.statusParaSalvar;
      }
      if (statusFluxo && statusFluxo === 'REPROVADO') {
        objArmazenamento.indAtivo = false;
      } else if (statusFluxo === null && this.podeInativarUsuario()) {
        statusFluxo = 'EM_CADASTRO';
      } else if (statusFluxo === null && this.usuario.statusFluxo === 'APROVADO' && this.isUsuarioAprovador) {
        statusFluxo = this.usuario.statusFluxo;
      } else if (statusFluxo === null && this.usuario.statusFluxo && this.usuario.indAtivo && this.isUsuarioAprovador) {
        statusFluxo = 'APROVADO';
      }
      objArmazenamento.statusFluxo = statusFluxo;
      objArmazenamento.justificativaAprovacao = this.justificativaAprovacaoReprovacaoUsuario;
      objArmazenamento.dataAlterada = dataAlterada || null;
      if (this.usuario.dtaInicioVigenciaPrevia) {
        if (this.isDataAlterada && this.isUsuarioAprovador) {
          this.indDtaPreviaAlteradaPorAprovador = true;
          objArmazenamento.dtaInicioVigenciaPrevia = this.isDataInicioVigenciaAlterada
            ? this.usuario.dtaInicioVigencia : this.usuario.dtaInicioVigenciaPrevia;
          objArmazenamento.dtaFimVigenciaPrevia = this.isDataFimVigenciaAlterada()
            ? this.usuario.dtaFimVigencia : this.usuario.dtaFimVigenciaPrevia;
        } else {
          objArmazenamento.dtaInicioVigenciaPrevia = this.usuario.dtaInicioVigenciaPrevia;
          objArmazenamento.dtaFimVigenciaPrevia = this.usuario.dtaFimVigenciaPrevia;
        }
      }
      objArmazenamento.indDtaPreviaAlteradaPorAprovador = this.indDtaPreviaAlteradaPorAprovador;
      objArmazenamento.isGrupoFornecedorAlterado = this.isGrupoFornecedorAlterado;
      if (statusFluxo === 'APROVADO' && this.usuario.dtaInicioVigenciaPrevia && !this.usuario.dtaInicioVigencia) {
        objArmazenamento.dtaInicioVigencia = objArmazenamento.dtaInicioVigenciaPrevia;
        objArmazenamento.dtaFimVigencia = objArmazenamento.dtaFimVigenciaPrevia;
      }
      if (statusFluxo === 'APROVADO' && !this.usuario.dtaInicioVigenciaPrevia && this.usuario.dtaInicioVigencia
       && this.usuario.dtaFimVigencia && this.usuario.indUsuarioExternoMaster && !this.usuario.indProcurador
       && !this.indAtivoOriginal && this.usuario.dataVigenciaExpirada) {
        const hoje = this.moment();
        objArmazenamento.dtaInicioVigencia = hoje.format('YYYY-MM-DD');
        objArmazenamento.dtaFimVigencia = hoje.clone().add(1, 'year').format('YYYY-MM-DD');
      }
      if (this.salvarNovaDataVigenciaAprovadorAutorizado()) {
        const hoje = this.moment();
        objArmazenamento.dtaInicioVigencia = hoje.format('YYYY-MM-DD');
        objArmazenamento.dtaFimVigencia = hoje.clone().add(1, 'year').format('YYYY-MM-DD');
        objArmazenamento.indAtivo = true;
      }
      if (this.naoSalvarDataReprLegal()) {
        objArmazenamento.dtaInicioVigencia = null;
        objArmazenamento.dtaFimVigencia = null;
      }
      objArmazenamento.indRenovaVigencia = this.indRenovaVigencia;

      this.exibeAlertaLgpd();
      forceLoading();
      if (this.isNovoCadastro) {
        this.requestGravar(objArmazenamento, this.usuarioResource.gravar);
      } else {
        this.requestAtualizar(objArmazenamento, this.usuarioResource.atualizar);
      }
    },
    salvarNovaDataVigenciaAprovadorAutorizado() {
      return (this.indRenovaVigencia && (this.usuario.dataVigenciaAExpirar || this.usuario.dataVigenciaExpirada)
      && !this.usuario.indUsuarioExternoMaster) || (!this.indRenovaVigencia && !this.usuario.indUsuarioExternoMaster
      && this.indUsuarioExternoMasterOriginal);
    },
    naoSalvarDataReprLegal() {
      return !this.indUsuarioExternoMasterOriginal && this.usuario.indUsuarioExternoMaster
      && this.dtaInicioVigenciaOriginal.length > 0 && !this.isSolicitandoAprovacao;
    },
    podeInativarUsuario() {
      return this.usuario.statusFluxo === 'APROVADO' && !this.usuario.indAtivo && this.isUsuarioAprovador;
    },
    exibeAlertaLgpd() {
      if (this.indAmbienteProdutivo) return;

      const alertaLgpd = this.$t('message.lgpd');
      alert(alertaLgpd); // eslint-disable-line
    },
    aplicarTrimCamposTexto() {
      this.usuario.nomUsuario = this.usuario.nomUsuario.normalize('NFD').replace(/[\u0300-\u036f]/g, '').trim();
      this.usuario.email = this.usuario.email.trim();
      this.usuario.nome = this.usuario.nome.trim();
      if (this.usuario.matricula) {
        this.usuario.matricula = this.usuario.matricula.trim();
      }
      if (this.usuario.sobrenome) {
        this.usuario.sobrenome = this.usuario.sobrenome.trim();
      }
      if (this.usuario.cargo) {
        this.usuario.cargo = this.usuario.cargo.trim();
      }
      if (this.usuario.documento) {
        this.usuario.documento = this.usuario.documento.trim();
      }
    },
    requestAtualizar(object, resource) {
      resource({ id: object.id }, object)
        .then(() => {
          if (this.existeFluxosImpactadosPorInativacao) {
            if (this.indHabilitaAlterarFluxosImpactados && this.desabilitaFluxoAprovacaoUsuarioInativo) {
              skipLoading();
              Promise.all([
                this.enviarAcoesParaAnalise(),
                this.enviarApuracoesParaAnalise(),
                this.enviarContratosParaAnalise(),
              ]).then(() => {
                this.enviaEmailAvisoInativacao();
                this.dadosFluxosAprovacaoImpactados = [];
                this.indHabilitaAlterarFluxosImpactados = false;
              });
            }
            if (this.existeGrupoRepresentacaoConjuntoImpactadoPorAlteracaoDeGrupo) {
              Promise.all([
                this.enviarContratosRepresentacaoConjuntoParaAnalise(),
              ]).then(() => {
                this.dadosFluxosAprovacaoImpactados = [];
                this.existeGrupoRepresentacaoConjuntoImpactadoPorAlteracaoDeGrupo = false;
              });
            }
          }
          if (this.exibeTermoCadastro) {
            this.salvarTermoAceite();
          }
          this.indCancelandoEdicao = false;
          forceHideLoading();
          window.setTimeout(() => {
            this.$router.push({ name: 'usuario-fornecedor' });
            this.$toast(this.$t('message.atualizado_com_sucesso'));
          }, 500);
        })
        .catch((err) => {
          forceHideLoading();
          this.$toast(err.data.error);
        });
    },
    requestGravar(object, resource) {
      resource(object)
        .then((res) => {
          this.usuario.id = res.data;
          this.loginAntigo = '';
          if (this.exibeTermoCadastro) {
            this.salvarTermoAceite();
          }
          window.setTimeout(() => {
            this.indCancelandoEdicao = false;
            forceHideLoading();
            if (this.usuario.indUsuarioExternoMaster && this.podeCadastrarAnexos) {
              this.editUsuario(this.usuario.id);
            } else {
              this.$router.push({ name: 'usuario-fornecedor' });
              this.$toast(this.$t('message.adicionado_confira_tabela'));
            }
          }, 500);
        })
        .catch((err) => {
          forceHideLoading();
          if (err.bodyText && JSON.parse(err.bodyText).erros
              && (JSON.parse(err.bodyText).erros[0] === 'login.duplicado'
                  || JSON.parse(err.bodyText).erros[0] === 'omni.usuario.nom_usuario.already_exists')) {
            this.loginAntigo = this.usuario.nomUsuario;
            this.$refs.form.validate();
          }
          this.$toast(err.data.error);
        });
    },
    carregarUsuario(id) {
      this.usuarioResource.buscar({ id })
        .then((res) => {
          this.editar(res.body);
          this.tenantsUsuario = res.body.tenant?.split(',').map((t) => t.trim()) ?? [];
          forceHideLoading();
        })
        .catch((err) => {
          this.$error(this, err);
          forceHideLoading();
        });
    },
    editar(usuario) {
      this.usuario = new Usuario();
      this.usuario.construirAPartirDaConsultaCompleta({ ...usuario });
      this.indUsuarioExternoMasterOriginal = this.usuario.indUsuarioExternoMaster;
      this.isProcurador(this.usuario.indProcurador, true);
      if (this.canEdit && !this.isNovoCadastro
        && ((this.podeCadastrarFornecedorMaster && !this.podeCadastrarFornecedorRepresentanteLegal && usuario.indUsuarioExternoMaster)
        || (this.podeCadastrarFornecedorRepresentanteLegal && !this.podeCadastrarFornecedorMaster && !usuario.indUsuarioExternoMaster))) {
        this.forcaSomenteLeitura = true;
      }
      if (!this.isSomenteLeitura && this.$route.params.ind_novo_usuario && this.usuario.indUsuarioExternoMaster
        && this.podeCadastrarAnexos) {
        this.$refs.avisoAnexoDialog.open();
      }
      if (this.usuario.dtaInicioVigencia && this.usuario.dtaFimVigencia) {
        this.dtaInicioVigenciaOriginal = copyObject(this.usuario.dtaInicioVigencia);
        this.dtaFimVigenciaOriginal = copyObject(this.usuario.dtaFimVigencia);
      }
      if (this.idGrupoFornecedorEdicao !== null && this.grupoFornecedorEdicao) {
        this.usuario.grupofornecedor = this.grupoFornecedorEdicao;
        this.usuario.id_grupofornecedor = this.idGrupoFornecedorEdicao;
      }
      if (this.usuario.statusFluxo === 'APROVADO' && !this.usuario.indProcurador && this.usuario.dtaInicioVigencia && this.usuario.dtaFimVigencia) {
        this.usuarioAprovadoNaoProcurador = true;
      }
      if (this.usuario.dtaInicioVigencia) {
        this.dtaInicioVigencia = this.usuario.dtaInicioVigencia;
        this.dtaFimVigencia = this.usuario.dtaFimVigencia;
      }
      this.indAtivoOriginal = this.usuario.indAtivo;
      this.idGrupoFornecedorOriginal = usuario.idGrupoFornecedor;
      this.nomeGrupoFornecedorOriginal = usuario.nomeGrupoFornecedor;
      this.idGrupoFornecedorAtual = usuario.idGrupoFornecedor;

      montarEstruturaDinamica(usuario, this.metadadosUsuario, this.usuario);
      this.usuarioSemEdicao = copyObject(usuario);
    },
    setDialogContent(content, action, from) {
      this.dialog.content = content || this.$t('message.salvar_novo_registro');
      this.dialog.action = action || this.save;
      this.dialog.from = from || this.dialog.from;
    },
    buscarPerfis(content = '') {
      const params = {
        autocomplete: content,
        limit: 1000,
        page: 0,
      };
      return this.perfilResource.selecao(params)
        .then((res) => {
          if (res.data) {
            this.perfis = res.data.filter((perfil) => {
              perfil.indPerfilUsuarioExterno = this.converterStringParaBoolean(perfil.indPerfilUsuarioExterno);
              return perfil.indPerfilUsuarioExterno;
            });
          }
          this.selecionarPerfilAuto();
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    selecionarPerfilAuto() {
      if (this.isUsuarioExternoMaster) {
        this.usuario.idPerfil = this.usuarioLogado.idPerfil;
      } else if (this.perfis.length === 1) {
        this.usuario.idPerfil = this.perfis[0].id;
      }
    },
    converterStringParaBoolean(perfil) {
      return (String(perfil).toLowerCase() === 'true');
    },
    triggerClick(id) {
      document.getElementById(id).click();
    },
    buscarTermoAceite() {
      const param = { objetivo: 'CRIACAO_USUARIO_FORNECEDOR' };
      this.termoAceiteResources.buscarTermoPorObjetivo(param).then((resposta) => {
        this.termoAceite = resposta.data;
      }, (err) => {
        this.$error(this, err);
      });
    },
    buscarChaveFluxoRepresentanteLegal() {
      this.configSistemaResource.buscarChave({ chave: 'FLUXO_APROVACAO_USR_FORNE_REP_LEG' })
        .then((resp) => {
          this.indFluxoAprovacaoRepreLegal = resp.body;
        });
    },

    salvarTermoAceite() {
      this.termoAceite.id_usuario_cadastrado = this.usuario.id;
      this.termoAceiteResources.salvarAceiteCadastroUsuario(this.termoAceite)
        .then()
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    triggerAtivaUsuario(value) {
      if (!value && this.isNovoCadastro) {
        this.usuario.indUsuarioExternoMaster = false;
      }
    },
    setQuantidadeArquivos(quantidade = 0) {
      this.quantidadeArquivos = quantidade;
    },
    desativarUsuario() {
      this.usuario.indAtivo = false;
    },
    triggerAtivaUsuarioMaster() {
      if (!this.usuario.indUsuarioExternoMaster) {
        this.usuario.indProcurador = false;
        this.flagProcurador = false;
      }

      if ((!this.usuario.indUsuarioExternoMaster && !this.indUsuarioExternoMasterOriginal)
      || (this.usuario.indUsuarioExternoMaster && this.indUsuarioExternoMasterOriginal)) {
        this.dataApagada = false;
      } else if ((this.usuario.indUsuarioExternoMaster && !this.indUsuarioExternoMasterOriginal)
      || (!this.usuario.indUsuarioExternoMaster && this.indUsuarioExternoMasterOriginal)) {
        this.dataApagada = true;
      }

      if (!this.usuario.indUsuarioExternoMaster && !this.usuario.indAtivo) {
        this.usuario.indAtivo = true;
      }

      if (this.usuario.indUsuarioExternoMaster && this.quantidadeArquivos < 1) {
        this.usuario.indAtivo = false;
      }
      this.$forceUpdate();
      this.$refs.form.validate();
    },
    editUsuario(id) {
      this.$router.push({ name: 'editarUsuarioFornecedor', params: { id, ind_novo_usuario: true } });
      window.setTimeout(() => {
        window.location.reload();
      }, 500);
    },
    openModalAlteracaoData() {
      this.$refs.modalDataAlteracao.open();
    },
    changeIndAtivo() {
      if (!this.isSomenteLeitura && !this.indCancelandoEdicao) {
        if (!this.isNovoCadastro && this.indAtivoOriginal && !this.usuario.indAtivo && this.existeFluxosImpactadosPorInativacao) {
          const dados = {
            idUsuario: this.usuario.id,
            nomeFornecedor: this.usuario.nomeSobrenome,
            dadosFluxosAprovacaoImpactados: this.dadosFluxosAprovacaoImpactados,
            indReprovacaoUsuarioFornecedorMaster: false,
          };
          setTimeout(() => this.$refs.modalDadosFluxosDeAprovacaoImpactadosPorInativacaoUsuario.open(dados), 2E2);
          return;
        }
        if (!this.$refs.form.validate()) {
          return;
        }
        if (this.isDtaFinalMenorQueDtaAtual && this.usuario.indAtivo) {
          this.usuario.indAtivo = false;
          this.panelKey += 1;
          this.$toast(this.$t('errors.data.final_menor_data_atual'));
          return;
        }
        if (this.usuario.indUsuarioExternoMaster && this.indFluxoAprovacaoRepreLegal
            && this.permissaoSolicitarAprovacao && this.usuario.indAtivo && !this.isUsuarioAprovador) {
          this.usuario.indAtivo = false;
          this.panelKey += 1;
          setTimeout(() => this.$refs.confirmDialogSolicitarAprovacao
            .openWithParams(
              this.$t('title.atencao'),
              this.$t('message.solicitar_aprovacao_usuario'),
              (ok) => {
                if (ok) {
                  this.preparaDataSolicitarAprovacao();
                }
              },
            ));
        }
      }
    },
    validarSalvarUsuarioComRenovacaoVigencia() {
      this.indRenovaVigencia = true;
      this.validarSalvar();
    },
    validarSalvar() {
      if (this.usuario.ehEdicao() && this.isGrupoFornecedorAlterado
        && this.usuario.indPossuiRepresentacaoConjunto && this.usuario.indPossuiGrupoRepConjuntoElegivel) {
        this.existeGrupoRepresentacaoConjuntoImpactadoPorAlteracaoDeGrupo = true;
        this.abrirModalConfirmacaoInativarGrupoRepConjunto();
      } else {
        this.validarGrupoFornecedorAlterado();
      }
    },
    abrirModalConfirmacaoInativarGrupoRepConjunto(ref, from) {
      const nomeGrupoFornecedorAlteracao = `${this.usuario.grupofornecedor.id} - ${this.usuario.grupofornecedor.nomExtensao}`;
      const content = this.$t('message.aviso_alteracao_grupo_fornecedor_usr_com_grupo_rep', { grupoFornOriginal: this.nomeGrupoFornecedorOriginal, grupoFornAlteracao: nomeGrupoFornecedorAlteracao });
      this.setDialogContent(content, this.validarGrupoFornecedorAlterado, from || this.dialog.from);
      this.$refs.confirmDialogAlterouGrupoFornecedor.open();
    },
    validarGrupoFornecedorAlterado(ref, from) {
      if (!this.$refs.form.validate()) {
        return;
      }
      if (this.isDtaFinalMenorQueDtaAtual) {
        this.usuario.indAtivo = false;
        this.panelKey += 1;
        this.$toast(this.$t('errors.data.final_menor_data_atual'));
      }
      // regra alterada para quando alterar a data e o grupo fornecedor, aparecer somente o modal de data alterada para solicitar aprovação
      if (this.usuario.indUsuarioExternoMaster && this.indFluxoAprovacaoRepreLegal
          && this.permissaoSolicitarAprovacao && this.isGrupoFornecedorAlterado && !this.isUsuarioAprovador
        && !this.isDataAlterada) {
        this.usuario.indAtivo = false;
        this.panelKey += 1;
        const nomeGrupoFornecedorAlteracao = `${this.usuario.grupofornecedor.id} - ${this.usuario.grupofornecedor.nomExtensao}`;
        setTimeout(() => this.$refs.confirmDialogSolicitarAprovacao
          .openWithParams(
            this.$t('title.atencao'),
            this.$t('message.solicitar_aprovacao_usuario_por_troca_grupo_fornecedor', { grupoFornOriginal: this.nomeGrupoFornecedorOriginal, grupoFornAlteracao: nomeGrupoFornecedorAlteracao }),
            (ok) => {
              if (ok) {
                this.statusParaSalvar = 'AGUARDANDO_APROVACAO';
                this.openSaveDialog(ref, from);
              }
            },
          ));
      } else {
        this.resetaStatusParaSalvar();
        this.openSaveDialog(ref, from);
      }
    },
    resetaStatusParaSalvar() {
      this.statusParaSalvar = null;
    },
    cancelarEdicaoData() {
      this.usuario.dtaInicioVigencia = this.dtaInicioVigenciaOriginal;
      this.usuario.dtaFimVigencia = this.dtaFimVigenciaOriginal;
      this.dtaInicioVigencia = this.dtaInicioVigenciaOriginal;
      this.dtaFimVigencia = this.dtaFimVigenciaOriginal;
      this.menuKey += 1;
      this.$refs.form.resetValidation();
    },
    buscaTermoAceiteUsuarioCadastro(idUsuario) {
      this.usuarioResource.buscaTermoAceiteUsuarioCadastro(({ idUsuario }))
        .then((res) => {
          this.existeTermoAceite = res.body;
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    setarPaginaCarregada(indPaginaCarregada) {
      this.isPaginaCarregada = indPaginaCarregada;
    },
    indAtivoPadrao() {
      if (!this.$route.params.id && this.usuario.indUsuarioExternoMaster) {
        this.usuario.indAtivo = false;
      }
    },
    isDataFimMaiorInicio() {
      const dtInicio = this.moment(this.dtaInicioVigenciaFormatada, 'DD/MM/YYYY');
      const dtFinal = this.moment(this.dtaFimVigenciaFormatada, 'DD/MM/YYYY');
      return dtFinal.isAfter(dtInicio);
    },
    isDataNaoVencida() {
      if (this.usuario.dtaFimVigencia || this.usuario.dtaFimVigenciaPrevia) {
        const hoje = this.moment();
        const dtFinal = !this.usuario.dtaFimVigencia ? this.moment(this.usuario.dtaFimVigenciaPrevia, 'YYYY-MM-DD') : this.moment(this.usuario.dtaFimVigencia, 'YYYY-MM-DD');
        return dtFinal.isSameOrAfter(hoje);
      }
      return false;
    },
    isDataFimVigenciaAlterada() {
      return this.usuario.dtaFimVigencia && this.dtaFimVigenciaOriginal !== this.usuario.dtaFimVigencia;
    },
    isDataNaoVencidaEmTrintaDias() {
      if (this.usuario.dtaFimVigencia && (this.isDataFimVigenciaAlterada() || this.isSolicitandoAprovacao)) {
        const vigenciaTrintaDias = this.moment().add(30, 'days');
        const dtFinal = this.moment(this.usuario.dtaFimVigencia, 'YYYY-MM-DD');
        return dtFinal.isAfter(vigenciaTrintaDias);
      }
      return true;
    },
    setarDataInicioNoUsuario() {
      this.usuario.dtaInicioVigencia = this.dtaInicioVigencia;
      if (!this.usuario.dtaFimVigencia) {
        this.usuario.dtaFimVigencia = this.usuario.dtaFimVigenciaPrevia;
        this.dtaFimVigencia = this.usuario.dtaFimVigenciaPrevia;
      }
    },
    setarDataFimNoUsuario() {
      this.usuario.dtaFimVigencia = this.dtaFimVigencia;
      if (!this.usuario.dtaInicioVigencia) {
        this.usuario.dtaInicioVigencia = this.usuario.dtaInicioVigenciaPrevia;
        this.dtaInicioVigencia = this.usuario.dtaInicioVigenciaPrevia;
      }
    },
    buscaDadosPerfilAprovador() {
      return this.perfilResource.buscaIdPerfilUsuarioAprovador()
        .then((res) => {
          this.idPerfilAprovador = res.data;
        });
    },
    cancelaAcaoInativar() {
      this.usuario.indAtivo = true;
    },
    alterarStatusEntidadesImpactadasPorInativacaoUsuario(justificativa, indReprovacaoUsuarioFornecedorMaster) {
      if (!this.$refs.form.validate()) {
        return;
      }
      this.indHabilitaAlterarFluxosImpactados = true;
      if (indReprovacaoUsuarioFornecedorMaster) {
        this.justificativaAprovacaoReprovacaoUsuario = justificativa;
        this.save('REPROVADO');
      } else {
        this.save();
      }
    },
    buscaDadosFluxosAprovacaoImpactados(idUsuario) {
      this.usuarioResource.dadosFluxosAprovacaoImpactados(({ idUsuario }))
        .then((res) => {
          this.dadosFluxosAprovacaoImpactados = res.body;
          if (Object.keys(this.dadosFluxosAprovacaoImpactados).length > 0) {
            this.dadosFluxosAprovacaoImpactados.idsCampanha = this.dadosFluxosAprovacaoImpactados.idsCampanha && this.dadosFluxosAprovacaoImpactados.idsCampanha.length ? this.dadosFluxosAprovacaoImpactados.idsCampanha.split(',').map(Number) : [];
            this.dadosFluxosAprovacaoImpactados.idsApuracao = this.dadosFluxosAprovacaoImpactados.idsApuracao && this.dadosFluxosAprovacaoImpactados.idsApuracao.length ? this.dadosFluxosAprovacaoImpactados.idsApuracao.split(',').map(Number) : [];
            this.dadosFluxosAprovacaoImpactados.idsContrato = this.dadosFluxosAprovacaoImpactados.idsContrato && this.dadosFluxosAprovacaoImpactados.idsContrato.length ? this.dadosFluxosAprovacaoImpactados.idsContrato.split(',').map(Number) : [];
            this.dadosFluxosAprovacaoImpactados.idsContratoRepresentacaoConjunto = this.dadosFluxosAprovacaoImpactados.idsContratoRepresentacaoConjunto && this.dadosFluxosAprovacaoImpactados.idsContratoRepresentacaoConjunto.length ? this.dadosFluxosAprovacaoImpactados.idsContratoRepresentacaoConjunto.split(',').map(Number) : [];
            if (this.dadosFluxosAprovacaoImpactados.idsCampanha.length > 0 || this.dadosFluxosAprovacaoImpactados.idsApuracao.length > 0
             || this.dadosFluxosAprovacaoImpactados.idsContrato.length > 0
             || this.dadosFluxosAprovacaoImpactados.idsContratoRepresentacaoConjunto.length > 0) {
              this.existeFluxosImpactadosPorInativacao = true;
            }
          }
        })
        .catch((err) => {
          this.$toast(err.data.error);
        });
    },
    enviarAcoesParaAnalise() {
      const listaAcoes = this.dadosFluxosAprovacaoImpactados.idsCampanha;
      const horaInativacao = this.pegaDataAtual();
      const promises = [];
      if (listaAcoes.length) {
        listaAcoes.forEach((idAcao) => {
          const params = {
            idAcao,
            observacao: this.$t('message.enviado_analise_automaticamente_por_inativacao_fornecedor', { nomeFornecedor: this.usuario.nomeSobrenome, horaInativacao }),
          };
          const promise = this.workflowAcaoResource.enviarAnaliseAcaoPorInativacaoFornecedor(params, params)
            .then(() => {
            })
            .catch((err) => {
              this.$error(this, err);
            });
          promises.push(promise);
        });
      }
      return Promise.all(promises);
    },
    enviarApuracoesParaAnalise() {
      const listaApuracoes = this.dadosFluxosAprovacaoImpactados.idsApuracao;
      const horaInativacao = this.pegaDataAtual();
      const promises = [];
      if (listaApuracoes.length) {
        listaApuracoes.forEach((idApuracao) => {
          const params = {
            idApuracao,
            observacao: this.$t('message.enviado_analise_automaticamente_por_inativacao_fornecedor', { nomeFornecedor: this.usuario.nomeSobrenome, horaInativacao }),
          };
          const promise = this.workflowApuracaoAcaoResource.enviarAnaliseApuracaoPorInativacaoFornecedor(params, params)
            .then(() => {
            })
            .catch((err) => {
              this.$error(this, err);
            });
          promises.push(promise);
        });
      }
      return Promise.all(promises);
    },
    enviarContratosParaAnalise() {
      const listaContratos = this.dadosFluxosAprovacaoImpactados.idsContrato;
      const horaInativacao = this.pegaDataAtual();
      const promises = [];
      if (listaContratos.length) {
        const promise = listaContratos.forEach((idContrato) => {
          const params = {
            idContrato,
            observacao: this.$t('message.enviado_analise_automaticamente_por_inativacao_fornecedor', { nomeFornecedor: this.usuario.nomeSobrenome, horaInativacao }),
          };
          this.workflowContratoResource.enviarAnaliseContratoPorInativacaoFornecedor(params, params)
            .then(() => {
            })
            .catch((err) => {
              this.$error(this, err);
            });
        });
        promises.push(promise);
      }
      return Promise.all(promises);
    },
    enviarContratosRepresentacaoConjuntoParaAnalise() {
      const listaContratos = this.dadosFluxosAprovacaoImpactados.idsContratoRepresentacaoConjunto;
      const horaInativacao = this.pegaDataAtual();
      const promises = [];
      if (listaContratos.length) {
        const promise = listaContratos.forEach((idContrato) => {
          const params = {
            idContrato,
            justificativa: this.$t('message.enviado_analise_automaticamente_por_alteracao_grupo_fornecedor', { nomeFornecedor: this.usuario.nomeSobrenome, horaInativacao }),
          };
          this.workflowContratoResource.enviaAnaliseContratoPorAlteracaoGrupoFornecedor(params, params)
            .then(() => {
            })
            .catch((err) => {
              this.$error(this, err);
            });
        });
        promises.push(promise);
      }
      return Promise.all(promises);
    },
    buscarChaveDesabilitarFluxoAprovacaoUsuarioInativo() {
      this.configSistemaResource.buscarChave({ chave: 'DESABILITAR_FLUXO_APROVACAO_USUARIO_INATIVO' })
        .then((resp) => {
          this.desabilitaFluxoAprovacaoUsuarioInativo = resp.body;
        });
    },
    enviaEmailAvisoInativacao() {
      const params = {
        listaCampanhas: this.dadosFluxosAprovacaoImpactados.idsCampanha,
        listaApuracoes: this.dadosFluxosAprovacaoImpactados.idsApuracao,
        listaContratos: this.dadosFluxosAprovacaoImpactados.idsContrato,
        idUsuario: this.idUsuario,
      };

      enviarEmailAvisoInativacaoFornecedor(params, this.$resource).then(() => {})
        .catch((err) => {
          this.$error(this, err);
        });
    },
    pegaDataAtual() {
      const dataAtual = new Date();
      const options = {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
      };
      const horaInativacao = dataAtual.toLocaleString('pt-BR', options);
      return horaInativacao;
    },
    valorAlterado(metadado) {
      if (metadado.label === 'grupofornecedor') {
        if (metadado.valor.selecao && metadado.valor.selecao.id) {
          this.idGrupoFornecedorAtual = metadado.valor.selecao.id;
        } else {
          this.idGrupoFornecedorAtual = null;
        }
        if (this.isGrupoFornecedorAlterado) {
          this.atualizarTabelas();
        }
      }
    },
    atualizarTabelas() {
      this.tableRepConjKey += 1;
    },
  },
  beforeMount() {
    forceLoading();
    Promise.all([
      this.popularMetadadosUsuario(),
      this.buscarTermoAceite(),
      this.buscarChaveFluxoRepresentanteLegal(),
      this.buscarChaveDesabilitarFluxoAprovacaoUsuarioInativo(),
      this.buscarPerfis(),
      this.buscaDadosPerfilAprovador(),
    ]).then(() => {
      if (this.$route.params.id) {
        this.indCancelandoEdicao = false;
        this.idUsuario = parseInt(this.$route.params.id, 10);
        Promise.all([
          this.carregarUsuario(this.idUsuario),
          this.buscaTermoAceiteUsuarioCadastro(this.idUsuario),
          this.buscaDadosFluxosAprovacaoImpactados(this.idUsuario),
        ]).then(() => this.setarPaginaCarregada(true));
      } else {
        this.indCancelandoEdicao = false;
        this.setarPaginaCarregada(true);
        forceHideLoading();
      }
    });
  },
  mounted() {
    if (this.podeCadastrarFornecedorRepresentanteLegal && !this.podeCadastrarFornecedorMaster) {
      this.usuario.indUsuarioExternoMaster = true;
    }
    if (this.podeCadastrarFornecedorMaster) {
      this.usuario.indUsuarioExternoMaster = false;
    }
    if (this.usuarioLogadoFornecedor) {
      this.buscarExtensoes(this.usuarioLogado.idGrupoFornecedor);
    } else {
      this.buscarExtensoes(null);
    }
    window.setTimeout(() => {
      this.indAtivoPadrao();
    }, 500);
  },
};
</script>
<style scoped>

#dados-sensiveis {
  border: 1px solid #c2c2c2;
  border-radius: 4px;
}

.row {
  margin-left: 0;
  margin-right: 0;
}

.hint-laranja .v-messages__message:not(.error--text) {
  color: orange !important;
}

.hint-laranja ::v-deep .v-messages__message:not(.error--text) {
  color: orange !important;
}

</style>
